import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './PublicNavigation.css';

const PublicNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLogin = location.pathname === '/login';
  const isSignUp = location.pathname === '/signup';

  const handleLandingNav = (sectionId) => (event) => {
    event.preventDefault();
    const hash = sectionId ? `#${sectionId}` : '';

    if (location.pathname !== '/') {
      navigate(
        { pathname: '/', hash },
        { state: { targetSection: sectionId } }
      );
    } else {
      const element = sectionId ? document.getElementById(sectionId) : null;
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        window.history.replaceState({}, '', hash);
      } else if (hash) {
        window.location.hash = hash;
      }
    }
  };

  return (
    <header className="landing-header">
      <div className="landing-header-inner">
        <Link to="/" className="brand">
          <img src="/logo.png" alt="Playthlon" className="brand-logo" />
          <span>Playthlon</span>
        </Link>
        <nav className="landing-nav">
          <a href="#features" className="link" onClick={handleLandingNav('features')}>Features</a>
          <a href="#faq" className="link" onClick={handleLandingNav('faq')}>FAQ</a>
          <Link
            to="/login"
            className={`link ${isLogin ? 'active' : ''}`}
          >
            Login
          </Link>
          <Link
            to="/signup"
            className={`btn-primary ${isSignUp ? 'active' : ''}`}
          >
            Sign up
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default PublicNavigation;


